'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { usePersistedValue, usePersistence, useResetPersistenceNoOrderContext } from '@segments/Storage';
import * as React from 'react';
import { OrderProvider as SharedOrderProvider, useOrderIdCtx, useSetOrderIdCtx } from '~shared/segments/Order';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Wrapper for the global provider of the order that is currently being edited.
 * Use `useOrderId` hook to access that info anywhere in the app.
 */
export var OrderProvider = function OrderProvider(_ref) {
  var children = _ref.children;

  var _usePersistence = usePersistence({
    key: "note"
  }),
      _usePersistence2 = _slicedToArray(_usePersistence, 3),
      resetNote = _usePersistence2[2];

  var onOrderClear = React.useCallback(function () {
    resetNote();
  }, [resetNote]);

  var _usePersistedValue = usePersistedValue({
    key: "order"
  }),
      _usePersistedValue2 = _slicedToArray(_usePersistedValue, 3),
      order = _usePersistedValue2[0],
      setOrder = _usePersistedValue2[1],
      resetOrder = _usePersistedValue2[2];

  var _resetPersistence = useResetPersistenceNoOrderContext();

  return /*#__PURE__*/_jsx(SharedOrderProvider, {
    order: order,
    setOrder: setOrder,
    resetOrder: resetOrder,
    onOrderClear: onOrderClear // omitting `withAuth` option, as it's not used in the shared usePersistedOrderId
    ,
    resetPersistence: function resetPersistence(clearOrder) {
      return _resetPersistence({
        clearOrder: clearOrder
      });
    },
    children: children
  });
};
export { useOrderIdCtx, useSetOrderIdCtx };